export const DEFAULT_WHATSAPP_PHONE = '213797607481';

export function normalizeWhatsAppPhone(phone) {
  return String(phone || '')
    .replace(/\D/g, '')
    .replace(/^0+/, '');
}

export function getWhatsAppNumbers(getContent) {
  const global = typeof getContent === 'function' ? getContent('global') || {} : {};
  const social = global.socialMedia || {};
  const list = social.whatsappNumbers;

  if (Array.isArray(list) && list.length > 0) {
    return list
      .filter((entry) => entry && entry.phone)
      .map((entry) => ({
        id: entry.id || 'primary',
        label: entry.label || entry.id || 'WhatsApp',
        phone: normalizeWhatsAppPhone(entry.phone),
      }));
  }

  const fallback = normalizeWhatsAppPhone(social.whatsapp || DEFAULT_WHATSAPP_PHONE);
  return [{ id: 'primary', label: 'Numéro principal', phone: fallback }];
}

export function resolveWhatsAppPhone(entity, getContent) {
  const direct = normalizeWhatsAppPhone(entity?.whatsappPhone);
  if (direct) return direct;

  const numbers = getWhatsAppNumbers(getContent);
  const selectedId = entity?.whatsappNumberId || 'primary';
  const match = numbers.find((n) => n.id === selectedId);
  return match?.phone || numbers[0]?.phone || DEFAULT_WHATSAPP_PHONE;
}

/** @deprecated use DEFAULT_WHATSAPP_PHONE */
export const WHATSAPP_PHONE = DEFAULT_WHATSAPP_PHONE;

export function buildWhatsAppUrl(message, phone, getContent) {
  const resolvedPhone = phone || resolveWhatsAppPhone({}, getContent) || DEFAULT_WHATSAPP_PHONE;
  const text =
    message || 'Bonjour, je souhaite des informations sur vos formations DentoXcellence.';
  return `https://wa.me/${normalizeWhatsAppPhone(resolvedPhone)}?text=${encodeURIComponent(text)}`;
}

export function programWhatsAppUrl(program, getContent) {
  if (program?.whatsappLink) return program.whatsappLink;
  const msg =
    program?.whatsappMessage ||
    `Bonjour, je souhaite des informations sur la formation : ${program?.title || 'DentoXcellence'}.`;
  return buildWhatsAppUrl(msg, resolveWhatsAppPhone(program, getContent), getContent);
}

export function formationWhatsAppUrl(formation, getContent) {
  if (formation?.whatsappLink) return formation.whatsappLink;
  const msg =
    formation?.whatsappProgramMessage ||
    `Bonjour, je souhaite des informations sur la formation : ${formation?.title || 'DentoXcellence'}.`;
  return buildWhatsAppUrl(msg, resolveWhatsAppPhone(formation, getContent), getContent);
}

export function serviceWhatsAppUrl(message, getContent) {
  return buildWhatsAppUrl(message, resolveWhatsAppPhone({}, getContent), getContent);
}
